import React, { useState, useEffect } from "react";
import PersistentDrawerLeft from '../../components/seller/Sidebar';
import "../../css/seller/produk.css"
import "../../css/card.css"
import Alert from "../../components/Alert";
import LoadingScreen from "../../components/LoadingScreen";
import NotFound from "../../components/NotFound";
import { useSearchParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import DeleteConfirm from "../../components/DeleteConfirm";
import { useNavigate } from 'react-router';

export default function SellerProduk() {
  const [isLoading, setIsLoading] = useState(false);
  const TICKET_PER_PAGE = 15;
  const [pageArr, setPageArr] = useState([]);
  const [viewProducts, setViewProducts] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [Data, setData] = useState([])
  const [user, setUser] = React.useState({});
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [alertActive, setAlertActive] = useState(true);
  const [alert, setAlert] = useState({});
  const [filter, setFilter] = useState('')
  const [productId, setproductId] = useState();
  const [confirmActive, setConfirmActive] = useState(false);
  const [imgId, setImgId] = useState();
  const [status, setStatus] = useState('')
  const navigate = useNavigate();


  let search = window.location.search;
  let params = new URLSearchParams(search);
  let fooCategory = params.get('category');
  let fooProduct = params.get('product');
  const query = search.substring(1, 9)
  const newQuery = query.replace(('?', '='), '')

  const activateAlert = () => {
    setAlertActive(true);
    setTimeout(() => {
      setAlertActive(false);
    }, 3000);
  };

  const fetchProduct = async (filter, idSeller) => {
    setIsLoading(true);
    let url = `https://w-shop-backend.vercel.app/api/products?idSeller=${idSeller}&page=1&`
    if (!!filter) {
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filter)) {
        params.set(key, value);
      };
      url += params.toString();
    };
    fetch(url, {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((body) => {
        const product = body.data;
        product.sort((a, b) => a.id - b.id);
        setData(product);
        setStatus(body.status)
        setIsLoading(false);
      })
      .catch(error => {
        setData([])
      });
  }

  useEffect(() => {
    let id
    user.id === undefined ? id = '-1' : id = user.id
    setIsLoading(true);
    filter === '' ? fetchProduct('', id) : fetchProduct({ product: filter }, id)
    setIsLoading(false);
  }, [fooProduct, fooCategory, newQuery, user.id, filter])

  useEffect(() => {
    setIsLoading(true)
    if (!searchParams.get('page')) {
      if (Data.length > TICKET_PER_PAGE) {
        setSearchParams({ page: 1 });
      } else {
        setViewProducts(Data);
      }
    } else {
      if (parseInt(searchParams.get('page')) > Math.ceil(Data.length / TICKET_PER_PAGE)) {
        setSearchParams({
          page: 1
        })
      } else {
        const page = searchParams.get('page');
        setViewProducts(Data.slice(TICKET_PER_PAGE * (page - 1), TICKET_PER_PAGE * page));
        const maxPage = Math.ceil(Data.length / TICKET_PER_PAGE);
        const pageList = [];
        const floor = ((page - 4) < 1) ? 1 : (page - 4);
        const ceil = ((4 + parseInt(page)) > maxPage) ? maxPage : (4 + parseInt(page));
        for (let i = floor; i <= ceil; i++) {
          pageList.push(i);
        };
        setPageArr(pageList);
      }
    }
    setIsLoading(false)
  }, [Data, searchParams, setSearchParams]);

  const handleShowConfirm = (idImg, idProduct) => {
    setConfirmActive(true);
    setproductId(idProduct);
    setImgId(idImg);
  };

  const handleHideConfirm = () => {
    setConfirmActive(false);
  };

  const handleDeleteProduct = async (idProduct, idImg) => {
    try {
      const url = `https://w-shop-backend.vercel.app/api/products/${idProduct}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + cookies.accessToken,
        },
      });
      const body = await response.json();
      if (body.status !== "success") {
        throw new Error(body.message);
      } else {
        const urlImg = `https://w-shop-backend.vercel.app/api/images?type=PRODUCT_IMG&imageId=${idImg}`;
        await fetch(urlImg, {
          method: 'DELETE',
          headers: {
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        })
        const event = {
          type: "alert",
          alert: {
            type: "success",
            message: "Produk ditambahkan ke keranjang",
          },
        };
        setCookie("event", event, { path: "/" });
        setAlert(event.alert);
        activateAlert();
        handleHideConfirm();
        setTimeout(() => {
          window.location.reload();
        }, 100);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: "danger",
        message: "Error: " + error.message,
      });
      activateAlert();
    }
  };

  const rupiah = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR"
    }).format(number);
  }

  const validateLocated = () => {
    if(!user.provinces && !user.address){
      setAlert({
        type: "danger",
        message: "Lengkapi lokasi anda",
      });
      activateAlert();
    }else{
      navigate('/sellerProduct/add')
    }
  }

  let productSeller = (<div className=" p-5">
    <DeleteConfirm
      active={confirmActive}
      message="Ingin menghapus produk ini dari keranjang ?"
      cancelHandler={handleHideConfirm}
      buttonMessage='Hapus'
      deleteHandler={() => {
        handleDeleteProduct(productId, imgId);
      }}
    />
    <LoadingScreen active={isLoading} />
    <Alert active={alertActive} type={alert.type} message={alert.message} />

    <div className="d-md-flex justify-content-between d-blok" role="search">
      <button  className="btn btn-outline-primary tambahProduk my-2" onClick={()=>{validateLocated()}}>Tambah Produk</button>
      <div className="d-flex ms-md-5 my-2">
        <input className="form-control inputSearch me-md-3 m-0 " type="search" placeholder="Cari" aria-label="Search" onChange={(e) => { setFilter(e.target.value) }} />
      </div>
    </div>
    <hr></hr>
    <div className="row" style={{ minHeight: "600px" }}>
      {
        status !== 'error' ? (
          viewProducts.map((items) => (
            <div className="col" key={items.id}>

              <div className="card mb-5" style={{ width: "256px", height: "379px", textDecoration: "none" }}>
                <img src={items.imgUrl} className="card-img-top" alt="..." style={{ height: "216px" }} />
                <div className="card-body">
                  <h6 className='cardTitle'>{items.product}</h6>
                  <h6 className='cardPrice'>{rupiah(items.price)}</h6>
                  <p>Stok : {items.stock} pcs</p>
                  <a href={`/sellerProduct/${items.id}`} className="bEdit btn btn-outline-primary">Edit</a>
                  <button className="bHapus btn btn-outline-danger ms-3" onClick={() => {
                    handleShowConfirm(items.imgId, items.id);
                  }}>Hapus</button>
                </div>
              </div>
            </div>
          )))
          : <NotFound />
      }
    </div>
    <div className='page-button-list'>
      {(parseInt(searchParams.get('page')) === 1) ? '' :
        <>
          <button
            className='page-arrow'
            onClick={() => { setSearchParams({ page: 1 }) }}
          >
            <img src='/dbl_left_arrow.svg' alt='to start' />
          </button>
          <button
            className='page-arrow'
            onClick={() => { setSearchParams({ page: parseInt(searchParams.get('page')) - 1 }) }}
          >
            <img src='/left_arrow.svg' alt='to prev' />
          </button>
        </>
      }
      {pageArr.map((x, i) => {
        return <button
          key={`page${i + 1}`}
          className={(x === parseInt(searchParams.get('page'))) ? 'active' : ''}
          onClick={(e) => {
            setSearchParams({
              page: x
            })
          }}
        >{x}</button>
      })
      }
      {(parseInt(searchParams.get('page')) === Math.ceil(Data.length / TICKET_PER_PAGE)) ? '' :
        <>
          <button
            className='page-arrow'
            onClick={() => { setSearchParams({ page: parseInt(searchParams.get('page')) + 1 }) }}
          >
            <img src='/right_arrow.svg' alt='to prev' />
          </button>
          <button
            className='page-arrow'
            onClick={() => { setSearchParams({ page: Math.ceil(Data.length / TICKET_PER_PAGE) }) }}
          >
            <img src='/dbl_right_arrow.svg' alt='to start' />
          </button>
        </>
      }
    </div>
  </div>)

  return (
    <div>
      <PersistentDrawerLeft userData={setUser} components={productSeller} titleAppBar={"Manajemen Produk"} />
    </div>
  );
}
